import { Box } from '@mui/material'
import { set } from 'lodash'
import React, { useEffect, useState } from 'react'
import { Bar } from 'react-chartjs-2'
import { makeGetRequest } from 'utils/api'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const color_list = [
  '#60829b',
  '#0dcaf0',
  '#307757',
  '#d63384',
  '#fd7e14',
  '#60829b',
  '#0dcaf0',
  '#307757',
  '#d63384',
  '#fd7e14',
  '#60829b',
  '#0dcaf0',
  '#307757',
  '#d63384',
  '#fd7e14',
  '#60829b',
  '#0dcaf0',
  '#307757',
  '#d63384',
  '#fd7e14',
  '#60829b',
  '#0dcaf0',
  '#307757',
  '#d63384',
  '#fd7e14',
]

export default function Chart3({ classificationSelected }) {
  const { t, i18n } = useTranslation('layout') // LAP-733 (GE022)
  const [data, setData] = useState({
    labels: [],
    datasets: [
      {
        label: '',
        data: [],
        backgroundColor: ['#60829b'],
        borderColor: ['#60829b'],
        barThickness: 20,
      },
    ],
  })
  useEffect(() => {
    fetchData(classificationSelected)
    // LAP-733 (GE022) — refresh on locale change for translated series label
  }, [classificationSelected, i18n.language])

  const fetchData = async () => {
    const response = await makeGetRequest(
      '/api/Finance/sous-cat-chart2/?classification=' + classificationSelected,
      {},
      true,
    )
    if (response.status === 200) {
      let labels = response.data.labels
      let datasets = []
      response.data.data.forEach((v, index) => {
        datasets.push({
          label: v.label,
          data: v.data,
          backgroundColor: color_list[index],
          borderColor: color_list[index],
          barThickness: 20,
        })
      })
      datasets.push({
        label: t('finance.monBudget.objectiveSingular'), // LAP-733 (GE022)
        data: [],
        backgroundColor: ['red'],
        borderColor: ['red'],
        barThickness: 20,
      })
      setData({ labels, datasets })
    }
  }
  const options = {
    indexAxis: 'x',
    responsive: true,
    aspectRatio: 1,
    maintainAspectRatio: false,

    plugins: {
      title: {
        display: true,
        position: 'bottom',
        text: classificationSelected,
      },
      datalabels: {
        display: false,
      },
      legend: {
        position: 'right',
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: { color: 'white' },
      },
      y: {
        stacked: true,
        ticks: { color: 'white' },
      },
    },
  }
  return (
    <Box height={350} position={'relative'} width={'100%'}>
      <Bar data={data} options={options} />
    </Box>
  )
}
